import { Link, Stack } from '@mui/material'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { TruncatedTextWithTooltip } from 'components/common/TruncatedTextWithTooltip'
import Icon from 'components/Icon'
import { ObservabilityToolIcon } from 'components/status-checks/common/ObservabilityToolIcon'
import { getStatusChecksUrls } from 'components/status-checks/status-checks-urls-utils'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'
import { OBSERVABILITY_TOOL_DISPLAY_NAME } from 'utils/status-checks/status-checks-utils'

import type { TeamExternalIntegration } from 'types/api/status-checks/status-check'

export const ObservabilityToolEditor: React.FC<{
  integration: TeamExternalIntegration
}> = ({ integration }) => {
  const statusCheckUrls = getStatusChecksUrls()

  const toolName =
    integration.observabilityToolType === ObservabilityToolType.GRAFANA
      ? OBSERVABILITY_TOOL_DISPLAY_NAME[ObservabilityToolType.GRAFANA]
      : integration.name

  const label = `Observability Tool: ${toolName}`

  return (
    <Stack
      direction="row"
      sx={{ alignItems: 'center', gap: 1, maxWidth: '100%' }}
    >
      <ObservabilityToolIcon integration={integration} />
      <TruncatedTextWithTooltip
        data-testid="observability-tool-edit"
        sx={{ maxWidth: 'calc(100% - 1rem)' }}
        tooltipProps={{ title: label }}
      >
        {label}
      </TruncatedTextWithTooltip>
      <Link
        component={RouterLink}
        to={statusCheckUrls.editAuthenticationFromTeamExternalIntegration(
          integration
        )}
      >
        <Icon icon="edit" />
      </Link>
    </Stack>
  )
}
